import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { DialogMensagemComponent } from './components/confirm-dialog/dialog-mensagem.component';
import { NextButtonComponent } from './components/next-button/next-button.component';
import { VariaveisComponent } from './components/variaveis/variaveis.component';
import { TooltipComponent } from '@angular/material/tooltip';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatIconModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatIconModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule, 
    MatButtonModule, 
    NextButtonComponent
  ],
  declarations: [
    VariaveisComponent,
    ConfirmDialogComponent,
    DialogMensagemComponent,
    NextButtonComponent
  ],
})
export class SharedModule { }
